import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { AuthProvider } from '../../providers/auth/auth';

@IonicPage({
  name: 'password-reset',
  segment: 'auth/reset-password/:token'
})
@Component({
  selector: 'page-reset-password',
  templateUrl: 'reset-password.html',
})
export class ResetPasswordPage {

  form: {
    password: string;
    password_conf: string;
  };
  token: string;
  err: string;
  loading: boolean;
  reseted: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public translate: TranslateService, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public authProvider: AuthProvider) {
    this.form = {
      password: "",
      password_conf: ""
    };

    this.token = this.navParams.get('token');
  }

  passwordReset() {
    // don't reset if the passwords don't match
    if (this.form.password !== this.form.password_conf) {
      let alert = this.alertCtrl.create({
        title: this.translate.instant('MODAL_ERROR_TITLE'),
        subTitle: this.translate.instant('MODAL_ERROR_PASSWORD_MISMATCH'),
        buttons: [
          this.translate.instant('BTN_OK')
        ]
      });
      alert.present();
      return false;
    }

    let loading = this.loadingCtrl.create({
      content: this.translate.instant('MSG_PLEASE_WAIT')
    });

    loading.present();

    this.authProvider.resetPassword(this.token, this.form)
      .subscribe(
        res => this.reseted = true,
        error => {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: this.translate.instant('MODAL_ERROR_TITLE'),
            subTitle: this.translate.instant('MODAL_ERROR_RESET_PASSWORD'),
            buttons: [
              this.translate.instant('BTN_OK')
            ]
          });
          alert.present();
        },
        () => {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: this.translate.instant('MODAL_SUCCESS_TITLE'),
            subTitle: this.translate.instant('MODAL_SUCCESS_RESET_PASSWORD'),
            buttons: [
              this.translate.instant('BTN_OK')
            ]
          });
          alert.present();
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/pages/auth/reset-password.ts